import { ChannelTypeInternal, TimeZoneKindInternal } from '../../../../data-access/gql-types/graphql';

export type TariffHoursRange = {
  from: number;
  to: number;
  timeZoneKind: TimeZoneKindInternal;
  pricingTier: number;
};

type TariffData = {
  name: string;
  hoursRanges: TariffHoursRange[];
  wholeWeekendCheaper: boolean;
  wholeHolidaysCheaper: boolean;
  ignoreSummerTimeChanges: boolean;
};

export type TariffItem = {
  operator: string;
  tariffs: TariffData[];
};

export const tariffData = {
  [ChannelTypeInternal.Optimizer]: 'optimizer',
  [ChannelTypeInternal.Meter]: 'meter',
};
